import { reject, omit } from 'lodash';
import { UserStore } from './../../@auth/user.store';
import { map } from 'rxjs/operators';
import { UtilsService } from './../utils/utils.service';
import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ModalService } from '../modal/modal.service';
import { Person, mapPeople, mapPerson } from 'src/app/models/person';
import { Apollo, gql } from 'apollo-angular';
import { cloneDeep } from "lodash";
import { Contacts } from "@capacitor-community/contacts";
import { AppAlertService } from '../app-alert/app-alert.service';
import { NativeSettings, AndroidSettings, IOSSettings } from 'capacitor-native-settings';

@Injectable({
  providedIn: 'root'
})
export class PersonService {


  entityName = 'people'
  constructor(
    private modalCtrl: ModalController,
    private modalService: ModalService,
    private utilsService: UtilsService,
    private apollo: Apollo,
    private userStore: UserStore,
    private appAlertService: AppAlertService

  ) {  }

  openPerson(id, data=null){
    return this.modalService.openPerson(id, data)
  }

  async getMyPeople(): Promise<Person[]>{
    return new Promise ((resolve, reject)=> {
      let userId = this.userStore.getUser().documentId
      let getPeopleGQL = gql ` query {
        people(filters: { user: { documentId: { eq: "${userId}" } } }, pagination: { limit: 100 }) {
           
              documentId
              uid
              firstName
              lastName
              user {
                uid
                documentId
              }
              picture {
          
                formats
                url
                  
              }

              contactPeriod
              circle
              uid
              createdAt
              updatedAt
              connections(sort: ["date:desc"], pagination: { pageSize: 1 }) {
                uid
                date
                  
              }
            
          }
        
      }
      `;
      return this.apollo
      .watchQuery({
        query: getPeopleGQL,
      })
      .valueChanges.subscribe(({data, error} : any) => {
       if (error) reject(error)
       else return resolve(mapPeople(cloneDeep(data.people), true))
      })

    })
  }

  async getMyPeopleOld(): Promise<Person[]>{

    let user = await this.utilsService.makeGetRequest(`users/me?populate=people`)


    return mapPeople({
      data: user?.people
    })
  }

  async getPerson(id): Promise<Person>{
    return mapPerson(await this.utilsService.makeGetRequest(`${this.entityName}/${id}?populate[connections][populate][0]=person&populate[picture][populate]=*`))
  }

  async listPeople(): Promise<Person[]>{
    return mapPeople(await this.utilsService.makeGetRequest(`${this.entityName}`))
  }

  editPerson(id, data: Object):Promise<Person>{
    const sanitizedData = omit(data, ['connections', 'user', 'picture']);
    return this.utilsService.makePutRequest(`${this.entityName}/${id}`, sanitizedData);
  }

  deletePerson(id){
    return this.utilsService.makeDeleteRequest(`${this.entityName}/${id}`)
  }

  async createPerson(data):Promise<Person>{
    data.user = this.userStore.getUser().documentId
    return await mapPerson(await this.utilsService.makePostRequest(`${this.entityName}`,data))
  }

  async bulkCreatePeople(data: Person[]): Promise<Person[]> {
    data.forEach(person => {
      person.user = this.userStore.getUser().documentId;
    });
    return await this.utilsService.makePostRequest(`${this.entityName}/bulk-create`, data );
  }

  async retrieveListOfContacts(selectMore=false){
    const projection = {
      // Specify which fields should be retrieved.
      name: true,
      phones: true,
      birthday: true,
      emails: true,
      addresses: true
    };

    try {

      return Contacts.checkPermissions().then(async (grantedStatus: PermissionStatus|any)=>{
        let granted = grantedStatus.contacts !== 'denied' && grantedStatus.contacts !== 'prompt' && grantedStatus.contacts !== 'prompt-with-rationale' && grantedStatus.contacts !== 'granted_limited';
        console.log('grantedStatus', grantedStatus)
        
        if (granted) {
          console.log('its granted!1')
          return await this.getContactsFromDevice(projection);

        } else {
          console.log('not granted')
          return Contacts.requestPermissions().then(async (grantedStatus2)=>{
            let granted2 = grantedStatus2.contacts !== 'denied' && grantedStatus2.contacts !== 'prompt' && grantedStatus2.contacts !== 'prompt-with-rationale';

            if (grantedStatus2.contacts === 'granted_limited' && selectMore) { 
              this.appAlertService.showErrorAlert('Only partial access to contacts is granted.');
              setTimeout(()=>{
                NativeSettings.open({
                  optionAndroid: AndroidSettings.ApplicationDetails, 
                  optionIOS: IOSSettings.App
                });
              }, 1000)
            }

            console.log('granted2', grantedStatus2)
            console.log('granted3', granted2)

            if (granted2) {
              return await this.getContactsFromDevice(projection);
            }
            else return null;
          })
        }
      })
    } catch (e) {
      return null;
    }
  }

  async getContactsFromDevice(projection){
    let result = await Contacts.getContacts({projection});
    console.log('result', result)
    if (result.contacts?.length > 0) {
      console.log("returning contacts")
      return result.contacts
    }
    else {
      console.log('No contacts found')
      return []
    }
  }

  async uploadPicture(file: File, person :Person): Promise<any> {
    const formData = new FormData();
    formData.append('files', file);

    try {
      // 1) Upload the file to Strapi v5 upload endpoint
      const uploadResponse: any = await this.utilsService.makeUploadRequest('upload', formData).toPromise();

      // normalize returned id / file object for v4/v5 compatibility
      let uploadedFile: any = null;
      if (Array.isArray(uploadResponse) && uploadResponse.length) {
        uploadedFile = uploadResponse[0];
      } else if (uploadResponse?.data && Array.isArray(uploadResponse.data) && uploadResponse.data.length) {
        uploadedFile = uploadResponse.data[0];
      } else if (uploadResponse?.data && uploadResponse.data.id) {
        uploadedFile = uploadResponse.data;
      } else if (uploadResponse?.id) {
        uploadedFile = uploadResponse;
      }

      if (!uploadedFile) {
        throw new Error('Upload failed: no file returned from Strapi.');
      }

      const fileId = uploadedFile.id ?? uploadedFile?.data?.id ?? null;
      if (!fileId) {
        throw new Error('Upload failed: no file id returned from Strapi.');
      }

      // 2) Attach the uploaded file to the Person entry using Strapi v5 content API
      // Strapi v5: update content entry by id with relation to media asset
      // Use payload that matches your utilsService expectations (data object)
      const updatePayload = {
        picture: fileId, // if picture is single media field; use [fileId] if it's a multiple relation
      };

      await this.utilsService.makePutRequest(`${this.entityName}/${person.documentId}`, updatePayload);

      // 3) Return the uploaded file object
      return uploadedFile;

    } catch (error) {
      console.error('Upload error:', error);
      throw error;
    }
  }

}

